import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router";
import { useLocalUserState } from "../util/useLocalUserState.ts";
import { useLocalSitesState } from "../util/useLocalSitesState.ts";
import { SitesMetadataTable } from "../components/SitesMetadataTable.tsx";
import { SitesMetadataFormType } from "../types/SitesMetadataFormType.ts";

const SitesMetadataForm = () => {
  const [user, setUser] = useLocalUserState();
  const [sites, setSites] = useLocalSitesState();
  const { control, handleSubmit } = useForm<SitesMetadataFormType>({
    mode: "onChange",
    defaultValues: {
      organizationName: user.organizationName || "",
      sites,
    },
  });
  const navigate = useNavigate();

  return (
    <Box>
      <Card>
        <CardContent>
          <form
            onSubmit={handleSubmit((data) => {
              setUser((prevUser) => ({
                ...prevUser,
                name: data.organizationName,
              }));
              setSites(data.sites);
              navigate("/sites/consumption");
            })}
          >
            <Grid container>
              <Grid size={12}>
                <Typography variant={"h4"}>Sites</Typography>
                <Typography variant={"body1"} mb={2}>
                  Enter your emissions profile for each site.
                </Typography>
                <Typography variant={"body2"} mb={4}>
                  Don’t know your profile? Call us.
                </Typography>
              </Grid>
              <Grid size={5}>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={2}
                  maxWidth={400}
                >
                  <Controller
                    name="organizationName"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="organizationName"
                        label="Organization Name"
                        {...field}
                      />
                    )}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container>
              <Grid size={12}>
                <SitesMetadataTable control={control} />
                <Button variant="contained" color="primary" type="submit">
                  Next
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SitesMetadataForm;
